'use client';

import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

import { memo } from 'react';
import Link from 'next/link';
import { IBranchPreview } from 'app/interfaces/branches';
import styles from './slider.module.scss';
import classNames from 'classnames';

function Slider({
  branches,
  onMouseEnter,
  onMouseLeave,
  activeItemId
}: {
  branches: IBranchPreview[];
  onMouseEnter?(id: number | string): void;
  onMouseLeave?(id: number | string): void;
  activeItemId?: string | number | null;
}) {
  return (
    <Swiper
      slidesPerView={'auto'}
      spaceBetween={-12}
      className={classNames(styles.slider)}
    >
      {branches.map((item, index) => {
        const isActive = activeItemId === item.id;
        return (
          <SwiperSlide key={index} className={classNames(styles.slide)}>
            <div className="px-3">
              <Link
                href={`/branches/${item.slug}`}
                onMouseEnter={() => onMouseEnter?.call(null, item.id)}
                onMouseLeave={() => onMouseLeave?.call(null, item.id)}
                className={classNames(
                  'text-black p-3 text-p4 rounded bg-sand-dark hover:bg-white button button-hovered whitespace-nowrap',
                  { 'bg-white': isActive }
                )}
              >
                {item.name}
              </Link>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default memo(Slider);
